import {APP_COLOR} from "../../../utils/constants"

export default function styles() {
    return {
        position: "relative" as "absolute",
        top: "5%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        flexDirection: "column" as 'column'
    }
}